import React, { useContext, useState } from 'react'
import { logInUser, createUser } from '../../api'
import LayoutContainer, {
    MaxWidthWrapper,
    PageContentWrapperSection,
} from '../../components/LayoutContainer.ui'
import UserContext from '../../data/user'
import { Link, useNavigate } from 'react-router-dom'
import Form from './components/AuthForm'
import { Input } from '../../components/Form.ui'
import { NAME } from '../../data/appVariables'
import Shirt from '../../components/Shirt'
import Button from '../../components/Button'
import Card, { CardGrid } from '../../components/Card.ui'

import { ReactComponent as Logo } from '../../assets/logo.svg'
import LogoLink from './Logo'
const VerificationPending = () => {
    const userCtx = useContext(UserContext)
    const api = userCtx.api
    const navigate = useNavigate()
    return (
        <>
            <h2>Verification email sent!</h2>
            <p>
                please complete the verification process by clicking on the link
                that was sent to your provided email address
            </p>
        </>
    )
}

export default VerificationPending
